import Skeleton from 'react-loading-skeleton'
import React from "react"

const ProfileDetailSkeleton = _ => {

    return (
            <div>
                <div className="row">
                    <div className="col-lg-6">
                        {/* <!--begin::List Widget 14--> */}
                        <div className="card card-custom gutter-b">
                            {/* <!--begin::Header--> */}
                            <div className="p-8">
                                <Skeleton  height={30}  />
                            </div>
                            {/* <!--end::Header--> */}
                            {/* <!--begin::Body--> */}
                            <div className="card-body pt-2">
                                {/* <!--begin::Item--> */}
                                <div className="d-flex flex-column mb-10">
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <Skeleton  height={20} className="m-2"  count={8}/>
                                    </div>
                                    {/* <!--end::Field--> */}
                                </div>
                                {/* <!--end::Item--> */}
                            </div>
                            {/* <!--end::Body--> */}
                        </div>
                        {/* <!--end::List Widget 14--> */}

                    </div>
                    <div className="col-lg-6">
                        {/* <!--begin::List Widget 14--> */}
                        <div className="card card-custom gutter-b">
                            {/* <!--begin::Header--> */}
                            <div className="p-8">
                                <Skeleton  height={30}  />
                            </div>
                            {/* <!--end::Header--> */}
                            {/* <!--begin::Body--> */}
                            <div className="card-body pt-2">
                                {/* <!--begin::Item--> */}
                                <div className="d-flex flex-column mb-10">
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <Skeleton  height={20} className="m-2"  count={8}/>
                                    </div>
                                    {/* <!--end::Field--> */}
                                </div>
                                {/* <!--end::Item--> */}
                            </div>
                            {/* <!--end::Body--> */}
                        </div>
                        {/* <!--end::List Widget 14--> */}
                        
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-6">
                        {/* <!--begin::List Widget 14--> */}
                        <div className="card card-custom gutter-b">
                            {/* <!--begin::Header--> */}
                            <div className="p-8">
                                <Skeleton  height={30}  />
                            </div>
                            {/* <!--end::Header--> */}
                            {/* <!--begin::Body--> */}
                            <div className="card-body pt-2">
                                {/* <!--begin::Item--> */}
                                <div className="d-flex flex-column mb-10">
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <Skeleton  height={20} className="m-2"  count={8}/>
                                    </div>
                                    {/* <!--end::Field--> */}
                                </div>
                                {/* <!--end::Item--> */}
                            </div>
                            {/* <!--end::Body--> */}
                        </div>
                        {/* <!--end::List Widget 14--> */}

                    </div>
                    <div className="col-lg-6">
                        {/* <!--begin::List Widget 14--> */}
                        <div className="card card-custom gutter-b">
                            {/* <!--begin::Header--> */}
                            <div className="p-8">
                                <Skeleton  height={30}  />
                            </div>
                            {/* <!--end::Header--> */}
                            {/* <!--begin::Body--> */}
                            <div className="card-body pt-2">
                                {/* <!--begin::Item--> */}
                                <div className="d-flex flex-column mb-10">
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <Skeleton  height={20} className="m-2"  count={8}/>
                                    </div>
                                    {/* <!--end::Field--> */}
                                </div>
                                {/* <!--end::Item--> */}
                            </div>
                            {/* <!--end::Body--> */}
                        </div>
                        {/* <!--end::List Widget 14--> */}
                        
                    </div>
                </div>

            </div>
                
    )
}

export default ProfileDetailSkeleton